import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { TrustTable } from "../../UI/Advertising/trust/TrustTable";

const TrustPanel = () => {
  return (
    <div>
      <PanelHead title="Trust" />
      <PanelBody content={<TrustTable />} />
    </div>
  );
};

export default React.memo(TrustPanel);
